import { render, staticRenderFns } from "./DashboardOverviewNumberOfMyTodayOrdersTile.vue?vue&type=template&id=77f8b1a9"
import script from "./DashboardOverviewNumberOfMyTodayOrdersTile.vue?vue&type=script&lang=js"
export * from "./DashboardOverviewNumberOfMyTodayOrdersTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports